import { PhoneNumberUtil } from 'google-libphonenumber';

export const SMS_CONSENT_FEATURE_FLAG = 'ent-12277-u-s-a-2-p-consent-capture';

const SMS_CONSENT_REGION_CODE = 'US';
const phoneNumberUtil = PhoneNumberUtil.getInstance();

interface PhoneNumberFields {
  country_code?: string | null;
  mobile_phone?: string | null;
}

function normaliseDialCode(countryCode?: string | null): string {
  return (countryCode || '').trim().replace(/^\+/, '');
}

function digitsOnly(value?: string | null): string {
  return (value || '').replace(/\D/g, '');
}

export function isUsPhoneNumber(countryCode?: string | null, mobilePhone?: string | null): boolean {
  const nationalNumber = digitsOnly(mobilePhone);
  if (!nationalNumber) return false;
  try {
    const phoneNumber = phoneNumberUtil.parse(`+${digitsOnly(countryCode)}${nationalNumber}`);
    return phoneNumberUtil.getRegionCodeForNumber(phoneNumber) === SMS_CONSENT_REGION_CODE;
  } catch {
    return false;
  }
}

export function isSamePhoneNumber(previous: PhoneNumberFields, next: PhoneNumberFields): boolean {
  return normaliseDialCode(previous.country_code) === normaliseDialCode(next.country_code)
    && digitsOnly(previous.mobile_phone) === digitsOnly(next.mobile_phone);
}
